import React, { useEffect, useRef, useState } from 'react';
import './PrivateLinkChip.css';
import api from '../wrapper/API';
import Icon from '../home/Icon';
import { useOffline } from '../context/OfflineContext';
import { copyText } from '../../util/clipboard';

/**
 * Chip "Link kopieren" in der Kopfzeile der Spieltag-Ansicht (nur private Events, nur Admins).
 * Der Link wird beim Öffnen der Seite einmal geladen — nicht erst beim Klick, sonst lehnt Safari
 * das Schreiben in die Zwischenablage ab (Nutzer-Geste geht über den await verloren).
 * Bewusst plain api.get (kein cachedGet): der geheime Key landet nicht im Offline-Cache.
 */
function PrivateLinkChip({ eventId }) {
  const { isOffline } = useOffline();
  const [link, setLink] = useState(null); // { url, signupClosed }
  const [loadFailed, setLoadFailed] = useState(false);
  const [feedback, setFeedback] = useState(null); // 'copied' | 'failed'
  const feedbackTimerRef = useRef(null);

  useEffect(() => {
    if (!eventId || isOffline || link) return undefined;
    let cancelled = false;
    setLoadFailed(false);
    api.get(`/PrivateEvent/${eventId}/Link`)
      .then(res => { if (!cancelled && res.data?.url) setLink(res.data); })
      .catch(() => { if (!cancelled) setLoadFailed(true); });
    return () => { cancelled = true; };
  }, [eventId, isOffline, link]);

  useEffect(() => () => clearTimeout(feedbackTimerRef.current), []);

  const handleCopy = () => {
    if (!link?.url) return;
    copyText(link.url).then(ok => {
      setFeedback(ok ? 'copied' : 'failed');
      clearTimeout(feedbackTimerRef.current);
      feedbackTimerRef.current = setTimeout(() => setFeedback(null), 2000);
    });
  };

  const disabled = !link?.url || isOffline;
  const title = isOffline
    ? 'Offline nicht verfügbar'
    : loadFailed
      ? 'Einladungslink konnte nicht geladen werden'
      : link?.signupClosed
        ? 'Einladungslink kopieren — die Anmeldung ist gerade geschlossen'
        : 'Einladungslink für Gäste in die Zwischenablage kopieren';

  return (
    <button
      type="button"
      className={`registrationsFilterChip privateLinkChip${feedback === 'copied' ? ' isCopied' : ''}`}
      onClick={handleCopy}
      disabled={disabled}
      title={title}
    >
      <Icon className={"registrationsFilterChipIcon"} icon={feedback === 'copied' ? 'check' : 'link'} />
      {feedback === 'copied' ? 'Kopiert' : feedback === 'failed' ? 'Kopieren fehlgeschlagen' : 'Link kopieren'}
    </button>
  );
}

export default PrivateLinkChip;
